import { useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";
import { ReactComponent as PostmanLogo } from "../assets/logo-light-full.svg";

const MinimalHeader = () => {
	return (
		<>
			<div className="mainHeader">
				<div className="firstContainerHero">
					<div className="firstContainer">
						<PostmanLogo className="firstPostmanLogo" />
					</div>
				</div>
			</div>
		</>
	);
};

export default MinimalHeader;
